export enum Programs {
  Screening = 1,
  KYC = 2,
  US_AML = 3,
  CAYMANS_AML = 4,
  LUXEMBOURG_AML = 5,
  NONE = 7,
}

export enum ProgramName {
  Screening = "Screening",
  KYC = "KYC",
  US_AML = "AML (US)",
  CAYMANS_AML = "AML (Caymans)",
  LUXEMBOURG_AML = "AML (Luxembourg)",
}
/**
 * Determines if the given program ID represents an AML program.
 *
 * @param programId - The ID of the program to check. Can be undefined if no program is selected.
 * @returns True if the program is an AML program, false otherwise.
 */
export const isAmlProgram = (programId: number | undefined): boolean => {
  if (!programId) return false;
  return (
    programId === Number(Programs.US_AML) ||
    programId === Number(Programs.LUXEMBOURG_AML) ||
    programId === Number(Programs.CAYMANS_AML) ||
    programId === Number(Programs.NONE) // Setting the None to the stringent program. In future we may change this.
  );
};

export const programDisplayName = (programId?: number): string | undefined => {
  switch (programId) {
    case Programs.Screening:
      return ProgramName.Screening;
    case Programs.KYC:
      return ProgramName.KYC;
    case Programs.US_AML:
      return ProgramName.US_AML;
    case Programs.CAYMANS_AML:
      return ProgramName.CAYMANS_AML;
    case Programs.LUXEMBOURG_AML:
      return ProgramName.LUXEMBOURG_AML;
  }
};
